export enum SeasonQueryKey {
  GET_ALL_SEASONS_BY_COMPANY = 'GET_ALL_SEASON_BY_COMPANY',
  GET_ALL_SEASON_AREAS_BY_SEASONS = 'getSeasonAreasFromSelectedSeasons',
  GET_ALL_SEASON_AREAS_BY_PROPERTY = 'GET_ALL_SEASON_AREAS_BY_PROPERTY',
  GET_ALL_SEASON_V2_AREAS_BY_PROPERTY = 'GET_ALL_SEASON_V2_AREAS_BY_PROPERTY'
}
